var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLapTopBottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\u0421\u043B\u043E\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 454 173",
    style: {
      enableBackground: "new 0 0 454 173"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#242424"
    },
    points: "448.394,132.102 448.38,144.884 440.117,140.973 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#242424"
    },
    points: "6.553,145.206 6.564,131.831 19.499,140.77 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424"
    },
    d: "M438.044,154.991H16.903c-6.854,0-11.813-6.354-9.958-12.759l25.411-87.73 c1.254-4.331,5.323-7.323,9.958-7.323h370.32c4.634,0,8.703,2.992,9.958,7.323l25.411,87.73 C449.857,148.638,444.898,154.991,438.044,154.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E8E8"
    },
    d: "M438.044,142.124H16.903c-6.854,0-11.813-6.545-9.958-13.144l25.411-90.376 c1.254-4.461,5.323-7.544,9.958-7.544h370.32c4.634,0,8.703,3.083,9.958,7.544l25.411,90.376 C449.857,135.579,444.898,142.124,438.044,142.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D5D6"
    },
    d: "M280.613,135.692H174.335c-4.755,0-8.464-4.117-7.97-8.846l2.173-20.814 c0.426-4.081,3.867-7.181,7.97-7.181h101.931c4.104,0,7.544,3.1,7.97,7.181l2.173,20.814 C289.077,131.575,285.368,135.692,280.613,135.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C1C7"
    },
    d: "M168.538,108.859c0.426-4.081,3.867-7.181,7.97-7.181h101.931c4.104,0,7.544,3.1,7.97,7.181 l2.101,20.123c0.113-0.69,0.149-1.404,0.072-2.137l-2.173-20.814c-0.426-4.081-3.867-7.181-7.97-7.181H176.508 c-4.104,0-7.544,3.1-7.97,7.181l-2.173,20.814c-0.076,0.732-0.041,1.447,0.072,2.137L168.538,108.859z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M70.952,43.422H57.468c-1.487,0-2.777,1.025-3.113,2.474l-0.528,2.276 c-0.465,2.004,1.056,3.919,3.113,3.919h13.724c1.61,0,2.969-1.198,3.171-2.795l0.288-2.276 C74.364,45.11,72.876,43.422,70.952,43.422z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M63.435,78.502H49.951c-1.487,0-2.777,0.94-3.113,2.267l-0.528,2.086 c-0.465,1.836,1.056,3.591,3.113,3.591h13.724c1.61,0,2.969-1.098,3.171-2.561l0.288-2.086 C66.847,80.049,65.359,78.502,63.435,78.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M84.136,54.799H57.855c-5.226,0-5.413,1.025-6.068,2.474l-1.029,2.276 c-1.294,2.564-0.278,4.528,6.068,3.919h26.749c5.675,0.271,5.786-1.198,6.18-2.795l0.561-2.276 C90.787,56.488,91.383,54.799,84.136,54.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M93.256,66.288H58.164c-6.978,0-7.228,1.025-8.103,2.474l-1.375,2.276 c-1.728,2.564-0.371,4.528,8.103,3.919h35.717c7.577,0.271,7.874-0.682,8.4-2.279l0.09-3.015 C100.997,66.786,99.865,66.288,93.256,66.288z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M100.329,43.422H84.184c-1.187,0-2.186,0.887-2.327,2.065l-0.478,3.98 c-0.168,1.395,0.922,2.624,2.327,2.624h16.045c1.165,0,2.153-0.855,2.32-2.008l0.577-3.98 C102.853,44.689,101.757,43.422,100.329,43.422z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M128.3,43.422h-16.259c-1.195,0-2.184,0.93-2.256,2.124l-0.252,4.148 c-0.079,1.3,0.954,2.397,2.256,2.397h16.325c1.209,0,2.204-0.951,2.258-2.159l0.186-4.148 C130.616,44.497,129.588,43.422,128.3,43.422z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M144.35,55.714h-16.259c-1.195,0-2.184,0.86-2.256,1.964l-0.252,3.836 c-0.079,1.202,0.954,2.217,2.256,2.217h16.325c1.209,0,2.204-0.88,2.258-1.997l0.186-3.836 C146.666,56.708,145.638,55.714,144.35,55.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M156.283,67.091h-16.259c-1.195,0-2.184,0.815-2.256,1.861l-0.252,3.634 c-0.079,1.139,0.954,2.101,2.256,2.101h16.325c1.209,0,2.204-0.834,2.258-1.892l0.186-3.634 C158.599,68.033,157.571,67.091,156.283,67.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M185.036,67.091h-16.259c-1.195,0-2.184,0.815-2.256,1.861l-0.252,3.634 c-0.079,1.139,0.954,2.101,2.256,2.101h16.325c1.209,0,2.204-0.834,2.258-1.892l0.186-3.634 C187.352,68.033,186.324,67.091,185.036,67.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M116.484,55.307H99.021c-1.284,0-2.345,0.878-2.423,2.003l-0.27,3.912 c-0.085,1.226,1.025,2.261,2.423,2.261h17.533c1.298,0,2.367-0.897,2.425-2.037l0.2-3.912 C118.971,56.321,117.867,55.307,116.484,55.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M124.001,78.385h-17.463c-1.284,0-2.345,0.878-2.423,2.003l-0.27,3.912 c-0.085,1.226,1.025,2.261,2.423,2.261h17.533c1.298,0,2.367-0.897,2.425-2.037l0.2-3.912 C126.488,79.399,125.384,78.385,124.001,78.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M93.979,78.385h-16.86c-1.239,0-2.265,0.878-2.34,2.003l-0.261,3.912 c-0.082,1.226,0.989,2.261,2.34,2.261h16.928c1.254,0,2.285-0.897,2.342-2.037l0.193-3.912 C96.381,79.399,95.315,78.385,93.979,78.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M127.778,66.59h-17.463c-1.284,0-2.345,0.878-2.423,2.003l-0.27,3.912 c-0.085,1.226,1.025,2.261,2.423,2.261h17.533c1.298,0,2.367-0.897,2.425-2.037l0.2-3.912 C130.265,67.604,129.161,66.59,127.778,66.59z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M248.387,78.385h-99.67c-7.327,0-12.55-0.586-12.994,0.54l-1.674,5.365 c-0.459,2.507-0.459,2.507,13.125,2.272l110.769,0.608c4.724,0,4.3-1.321,4.131-2.641l-1.625-5.756 C260.212,78.111,256.284,78.385,248.387,78.385z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M156.096,43.422h-15.785c-1.33,0-2.444,1.007-2.577,2.33l-0.352,3.488 c-0.154,1.526,1.044,2.85,2.577,2.85h16.002c1.392,0,2.535-1.099,2.588-2.49l0.135-3.488 C158.742,44.644,157.566,43.422,156.096,43.422z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M172.654,55.714h-15.785c-1.33,0-2.444,0.931-2.577,2.155l-0.352,3.225 c-0.154,1.411,1.044,2.636,2.577,2.636h16.002c1.392,0,2.535-1.017,2.588-2.303l0.135-3.225 C175.3,56.844,174.124,55.714,172.654,55.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M184.172,43.422h-14.783c-1.639,0-2.962,1.338-2.944,2.976l0.031,2.781 c0.018,1.613,1.33,2.911,2.944,2.911h14.645c1.581,0,2.88-1.249,2.941-2.83l0.108-2.781 C187.178,44.811,185.842,43.422,184.172,43.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M200.831,55.307h-14.783c-1.639,0-2.962,1.3-2.944,2.892l0.031,2.702 c0.018,1.567,1.33,2.828,2.944,2.828h14.645c1.581,0,2.88-1.214,2.941-2.749l0.108-2.702 C203.838,56.656,202.502,55.307,200.831,55.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M212.92,67.091h-14.783c-1.639,0-2.962,1.204-2.944,2.678l0.031,2.502 c0.018,1.451,1.33,2.619,2.944,2.619h14.645c1.581,0,2.88-1.124,2.941-2.546l0.108-2.502C215.926,68.34,214.59,67.091,212.92,67.091 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M229.588,55.51h-14.783c-1.639,0-2.962,1.3-2.944,2.892l0.031,2.702 c0.018,1.567,1.33,2.828,2.944,2.828h14.645c1.581,0,2.88-1.214,2.941-2.749l0.108-2.702C232.594,56.86,231.258,55.51,229.588,55.51 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M242.184,67.091H227.4c-1.639,0-2.962,1.204-2.944,2.678l0.031,2.502 c0.018,1.451,1.33,2.619,2.944,2.619h14.645c1.581,0,2.88-1.124,2.941-2.546l0.108-2.502 C245.19,68.34,243.854,67.091,242.184,67.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M271.135,67.352h-14.783c-1.639,0-2.962,1.204-2.944,2.678l0.031,2.502 c0.018,1.451,1.33,2.619,2.944,2.619h14.645c1.581,0,2.88-1.124,2.941-2.546l0.108-2.502 C274.141,68.601,272.805,67.352,271.135,67.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M257.218,55.51h-14.783c-1.639,0-2.962,1.3-2.944,2.892l0.031,2.702 c0.018,1.567,1.33,2.828,2.944,2.828h14.645c1.581,0,2.88-1.214,2.941-2.749l0.108-2.702C260.224,56.86,258.889,55.51,257.218,55.51 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M286.45,55.497l-15.12,0.026c-1.676,0.003-3.027,1.305-3.005,2.897l0.036,2.702 c0.021,1.567,1.366,2.826,3.015,2.823l14.978-0.026c1.617-0.003,2.944-1.219,3.004-2.754l0.106-2.702 C289.527,56.841,288.158,55.494,286.45,55.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M300.875,66.766l-15.12,0.026c-1.676,0.003-3.027,1.305-3.006,2.897l0.036,2.702 c0.021,1.567,1.366,2.826,3.015,2.823l14.978-0.026c1.617-0.003,2.944-1.219,3.004-2.754l0.106-2.702 C303.951,68.11,302.583,66.763,300.875,66.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M314.351,55.497l-15.12,0.026c-1.676,0.003-3.027,1.305-3.006,2.897l0.036,2.702 c0.021,1.567,1.366,2.826,3.015,2.823l14.978-0.026c1.617-0.003,2.944-1.219,3.004-2.754l0.106-2.702 C317.428,56.841,316.06,55.494,314.351,55.497z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M212.158,43.422h-15.694c-1.37,0-2.474,1.123-2.45,2.493l0.066,3.767 c0.023,1.337,1.113,2.408,2.45,2.408h15.482c1.316,0,2.398-1.04,2.449-2.356l0.146-3.767 C214.661,44.578,213.549,43.422,212.158,43.422z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M239.85,43.422h-15.193c-1.376,0-2.484,1.128-2.46,2.504l0.065,3.747 c0.023,1.342,1.118,2.418,2.46,2.418h15.028c1.333,0,2.424-1.062,2.46-2.395l0.1-3.747C242.347,44.564,241.235,43.422,239.85,43.422 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M268.086,43.422h-15.268c-1.316,0-2.376,1.079-2.353,2.395l0.069,3.961 c0.022,1.284,1.069,2.313,2.353,2.313h15.093c1.275,0,2.319-1.016,2.353-2.291l0.106-3.961 C270.474,44.515,269.41,43.422,268.086,43.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M296.446,43.422h-15.533c-1.258,0-2.272,1.032-2.25,2.29l0.073,4.167 c0.021,1.228,1.023,2.211,2.25,2.211h15.752c1.305,0,2.336-1.106,2.245-2.408l-0.292-4.167 C298.609,44.337,297.628,43.422,296.446,43.422z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M287.33,78.478l-15.12,0.026c-1.676,0.003-3.027,1.305-3.005,2.897l0.036,2.702 c0.021,1.567,1.366,2.826,3.015,2.823l14.978-0.026c1.617-0.003,2.944-1.219,3.004-2.754l0.106-2.702 C290.407,79.821,289.039,78.475,287.33,78.478z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M316.315,78.478l-15.12,0.026c-1.676,0.003-3.027,1.305-3.005,2.897l0.036,2.702 c0.021,1.567,1.366,2.826,3.015,2.823l14.978-0.026c1.617-0.003,2.944-1.219,3.004-2.754l0.106-2.702 C319.392,79.821,318.024,78.475,316.315,78.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M345.713,83.636l-15.12,0.026c-1.676,0.003-3.028,0.509-3.009,1.126l0.033,1.047 c0.019,0.607,1.363,1.094,3.012,1.091l14.978-0.026c1.617-0.003,2.945-0.476,3.007-1.071l0.109-1.047 C348.788,84.154,347.421,83.633,345.713,83.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M405.71,83.636l-15.12,0.026c-1.676,0.003-3.028,0.509-3.009,1.126l0.033,1.047 c0.019,0.607,1.363,1.094,3.012,1.091l14.978-0.026c1.617-0.003,2.945-0.476,3.007-1.071l0.109-1.047 C408.785,84.154,407.418,83.633,405.71,83.636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M329.893,66.766l-15.12,0.026c-1.676,0.003-3.027,1.305-3.005,2.897l0.036,2.702 c0.021,1.567,1.366,2.826,3.015,2.823l14.978-0.026c1.617-0.003,2.944-1.219,3.004-2.754l0.106-2.702 C332.97,68.11,331.602,66.763,329.893,66.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M324.566,43.422h-16.501c-1.139,0-2.057,0.934-2.037,2.073l0.08,4.594 c0.019,1.111,0.926,2.002,2.037,2.002h16.481c1.136,0,2.052-0.928,2.037-2.064l-0.06-4.594 C326.589,44.318,325.681,43.422,324.566,43.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M344.544,55.497h-16.501c-1.139,0-2.057,0.888-2.037,1.971l0.08,4.368 c0.019,1.056,0.926,1.903,2.037,1.903h16.481c1.136,0,2.052-0.883,2.037-1.962l-0.06-4.368 C346.567,56.349,345.659,55.497,344.544,55.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M359.172,66.87h-16.502c-1.139,0-2.057,0.888-2.037,1.971l0.08,4.368 c0.019,1.056,0.926,1.903,2.037,1.903h16.481c1.136,0,2.052-0.883,2.037-1.962l-0.06-4.368 C361.195,67.721,360.287,66.87,359.172,66.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M375.039,78.456l-16.62,0.005c-1.146,0-1.907,0.872-1.69,1.931l0.873,4.251 c0.21,1.022,1.267,1.84,2.376,1.84h16.457c1.135,0,1.91-0.853,1.724-1.899L377.4,80.33 C377.215,79.292,376.162,78.456,375.039,78.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M371.983,55.601H355.17c-1.161,0-2.096,0.888-2.075,1.971l0.082,4.368 c0.02,1.056,0.943,1.903,2.075,1.903h16.792c1.157,0,2.091-0.883,2.076-1.962l-0.061-4.368 C374.044,56.452,373.119,55.601,371.983,55.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M400.93,66.87h-28.564c-1.972,0-3.56,0.888-3.526,1.971l0.139,4.368 c0.034,1.056,1.602,1.903,3.526,1.903h30.293c1.966,0,3.552-0.883,3.526-1.962l-1.867-4.368 C403.477,67.26,402.86,66.87,400.93,66.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M401.133,55.497H384.02c-1.181,0-2.133,0.888-2.112,1.971l0.083,4.368 c0.02,1.056,0.96,1.903,2.112,1.903h17.091c1.178,0,2.128-0.883,2.113-1.962l-0.062-4.368 C403.23,56.349,402.289,55.497,401.133,55.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M365.148,52.091h34.436c1.281,0,2.228-1.192,1.938-2.44l-1.088-4.689 c-0.209-0.902-1.013-1.54-1.938-1.54H364.7c-1.174,0-2.092,1.011-1.981,2.179l0.448,4.689 C363.264,51.311,364.122,52.091,365.148,52.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D3333"
    },
    d: "M352.449,43.422h-15.711c-1.532,0-2.773,1.242-2.773,2.773v3.122c0,1.532,1.242,2.773,2.773,2.773 h15.826c1.572,0,2.829-1.304,2.771-2.875l-0.114-3.122C355.166,44.603,353.941,43.422,352.449,43.422z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapTopBottom);
export default __webpack_public_path__ + "static/media/lap-top-bottom.6ef0bfaf35921922c544ad9d4a931a69.svg";
export { ForwardRef as ReactComponent };